import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { useDispatch, useSelector} from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import _ from 'lodash';
import { openEditDriverModal, handleEditDriverModal } from '../../reducers/uiSlice';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import FullscreenLoading from '../Common/FullscreenLoading';
import DriverSearchList from './DriverSearchList';
import TopBar from '../Common/TopBar';
import DriverEditRecordList from './DriverEditRecordList';

const useStyles = makeStyles((theme)=> ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),    
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },  
  searchFab: {
    color: green[500],
    width: 40, 
    height: 40
  },
  table: {
    minWidth: 700,
    border: 1,    
  },  
  topBarButton: {
    marginLeft: theme.spacing(2),
    color: 'unset'
  },
  appBarClasses: {
    backgroundColor: '#424242',
    color: theme.palette.text.primary,
    padding: theme.spacing(1),
    boxShadow: 'none !important',
    paddingLeft: '0px !important',
    paddingRight: '0px !important'
  },
}))

export default function DriverList() {
  const classes = useStyles();
  const {t} = useTranslation('editDriver');
  const dispatch = useDispatch();
  const openModal = useSelector(openEditDriverModal) || false;

  const loading = useSelector(state => state.driver.logDriverOperationsLoading || state.driver.isDriverListLoading);

  const manageIndices = {
    driverSection: {
      id: 0,
      text: t('driver_profile')
    },
    editRecordSection: {
      id: 1,
      text: t('profile_edit_record')
    }
  }

  const [manageIndex, setManageIndex] = useState('driverSection');

  const handleManageIndex = (event) => {
    setManageIndex(event.target.value);
  }

  return (
    <Dialog 
        onClose={handleClose} 
        open={openModal}
        fullWidth={true}
        maxWidth='xl'
    >
    <DialogTitle>
      <TopBar 
        title={t('title_edit_driver')}
        buttonClasses={classes.topBarButton}
        appBarClasses={classes.appBarClasses}
        handleRadioChange={handleManageIndex}
        radios={manageIndices}
        radio={manageIndex}
        type={'modal'}
        onClose={handleClose}
      />                       
    </DialogTitle>       
    <DialogContent dividers className={classes.root} >
      {
        manageIndex === 'driverSection' ?
        <DriverSearchList />
        :
        <DriverEditRecordList />
      }
    </DialogContent>
    <FullscreenLoading open={loading}/>
    </Dialog>
  );

  function handleClose() {
    dispatch(handleEditDriverModal(false))
  } 
}
